<template>
  <mini-card :value="'$'+totalSubmittedPayouts" subtitle="Submitted" :previousValue="'$'+totalSubmittedPayoutsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-envelope-open-dollar text-primary"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last submission: &nbsp;<i>2020-03-29</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-Submitted-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    managePayouts () {
      alert('Feature coming soon!')
    },
    addPayout () {
      this.$store.dispatch('openModal', {name: 'Payout', mode: 'Create', object: new Payout({})})
    }
  },
  computed: {
    totalSubmittedPayouts () {
      return this.$store.getters.totalPayouts({status: Payout._status.SUBMITTED})
    },
    totalSubmittedPayoutsPrevious () {
      return this.$store.getters.totalPayoutsPrevious({status: Payout._status.SUBMITTED})
    }
  }
}
</script>

<style>

</style>